import { render, staticRenderFns } from "./cargoStatistics.vue?vue&type=template&id=0cfcee48&scoped=true"
import script from "./cargoStatistics.vue?vue&type=script&lang=js"
export * from "./cargoStatistics.vue?vue&type=script&lang=js"
import style0 from "./cargoStatistics.vue?vue&type=style&index=0&id=0cfcee48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfcee48",
  null
  
)

export default component.exports